/*@flow*/

export default (anchor: HTMLElement): Node | Document | HTMLElement => {
  let el = anchor;

  while (
    el &&
    el.parentNode &&
    (el.style.display === 'grid' ||
      withinRange(el.scrollHeight, el.offsetHeight, 10))
  ) {
    el = el.parentNode;
  }
  // HACK: Body element does not scroll, even though it satisfies our heuristic.
  // But Document does scroll.
  //
  if (el instanceof HTMLBodyElement) {
    return document;
  }
  return el;
};

const withinRange = (a, b, range) => Math.abs(a - b) < range;
